import { create } from "zustand";
import { persist } from "zustand/middleware";

import { LARUCHE_IDENTIFIER } from "@constants/index";


interface AppStore {
  users: Record<
    string,
    {
      patients: Record<
        string,
        {
          reason: string;
        }
      >;
    }
  >;

  tabs: {
    consultationTab?: string;
    appointmentCategoryTab?: string;
    appointmentStatusTab?: string;
    queueCategoryTab?: string;
    queueStatusTab?: string;
    createAppointmentTab?: string;
    labTab?: string;
    prescriptionTab?: string;
    radiologyTab?: string;
    immunizationTab?: string;
    recordsTab?: string;
    resourceManagementTab?: string;
    resourceManagementSubTab?: string;
  };
  setTabs: (arg: AppStore["tabs"]) => void;

  isNetworkDisconnected: boolean;
  setIsNetworkDisconnected: (isDisconnected: boolean) => void;

  setPatientReason: (userId: string, patientId: string, reason: string) => void;

  dangerouslyReset: () => void;
}

const initialState: Pick<AppStore, "isNetworkDisconnected" | "users" | "tabs"> =
  {
    users: {},
    tabs: {
      consultationTab: "new",
      appointmentCategoryTab: "homecare",
      appointmentStatusTab: "booked", // This should depend on user role, but for now all roles that can access appointments can access "booked"
      queueCategoryTab: "homecare",
      queueStatusTab: "booked", // This should depend on user role, but for now all roles that can access appointments can access "booked"
      createAppointmentTab: "new",
      labTab: "general",
      prescriptionTab: "general",
      radiologyTab: "general",
      immunizationTab: "general",
      recordsTab: "consultation",
      resourceManagementTab: "consultations",
      resourceManagementSubTab: "analysis",
    },
    isNetworkDisconnected: false,
  };

export const useAppStore = create<AppStore>()(
  persist(
    set => ({
      ...initialState,
      setPatientReason: (userId, patientId, reason) => {
        set(state => {
          return {
            users: {
              ...state.users,
              [userId]: {
                ...state.users[userId],
                patients: {
                  ...state.users[userId]?.patients,
                  [patientId]: { reason },
                },
              },
            },
          };
        });
      },
      setTabs: arg => set(state => ({ tabs: { ...state.tabs, ...arg } })),
      setIsNetworkDisconnected: arg => set({ isNetworkDisconnected: arg }),
      dangerouslyReset: () => {
        set(initialState);
      },
    }),

    {
      name: `${LARUCHE_IDENTIFIER}-app-store`,
      version: 2.4,
      migrate(persistedState, version) {
        // if (version < x.x) {
        // Just a simple reset
        persistedState = initialState;
        return persistedState;
        // }
      },
    }
  )
);
